import React from "react";
import { useSelector } from "react-redux";
import { TextField as TextFieldMUI, Popper, Typography, CircularProgress } from "@mui/material";
import { Autocomplete } from "formik-mui";
import { fieldToTextField } from "formik-mui";

const stylesPopper = (_) => ({
  popper: {
    maxWidth: "fit-content",
  },
});

const PopperMy = function (props) {
  return <Popper {...props} placement="bottom-start" style={stylesPopper.popper} />;
};

const FormikAutocompleteMenuItem = ({ textFieldProps, ...props }) => {
  const loading = useSelector((state) => state.menuItem.isLoading);
  const paths = useSelector((state) =>
    state.menuItem.data.map(({ id, path, name }) => ({ id, path, name })),
  );
  const {
    form: {
      values: { id },
    },
  } = props;
  const menuItemIds = useSelector((state) => {
    let menuItemSimplified = state.menuItem.data.map(({ id, name }) => ({
      id,
      name,
    }));

    menuItemSimplified = menuItemSimplified.filter((x) => !x.deleted && x.id !== id);

    menuItemSimplified = menuItemSimplified.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0,
    );

    menuItemSimplified = menuItemSimplified.map((x) => x.id);

    return menuItemSimplified;
  });

  const {
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name, value } = field;

  const getMenuItem = (id) => paths.find((x) => x.id === id) ?? { name: "", path: "" };
  const getMenuItemName = (id) => paths.find((x) => x.id === id)?.name ?? "";

  return (
    <Autocomplete
      {...props}
      {...field}
      PopperComponent={PopperMy} //Las opciones deben estar antes de los metedos getOptionLabel y renderOption.
      defaultValue={getMenuItemName(value)}
      getOptionLabel={(value) => {
        let prueba = getMenuItemName(value);

        return prueba;
      }}
      loading={loading}
      options={menuItemIds}
      renderInput={(props) => (
        <TextFieldMUI
          {...props}
          {...textFieldProps}
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {props.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={(value, _state) => {
        let { name, path } = getMenuItem(value);

        return (
          <Typography>
            {name}
            {path && <Typography color="textSecondary">{path}</Typography>}
          </Typography>
        );
      }}
      onBlur={() => setTouched({ [name]: true })}
      onChange={(_, value) => setFieldValue(name, value)}
    />
  );
};

export default FormikAutocompleteMenuItem;
